import React, { useState } from 'react';
import { Alert, Button, Col, Container, FormGroup, Input, Label, Row } from 'reactstrap';
import { getUsername } from './http';

export function ForgotUsernameContainer() {
  const [showConfirmationBox, setShowConfirmationBox] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [emailInput, setEmailInput] = useState('');
  const retrieveUsername = (email: string) => {
    setSubmitting(true);
    getUsername(email).finally(() => {
      setSubmitting(false);
      setShowConfirmationBox(true);
    })
  };
  return (

    <div className="blacklight">
      <Row style={{ marginTop: '10%' }}>
        <Col sm={12} md={4} lg={3}
          style={{ color: '#fff', background: 'var(--brand-navy)', height: '90px', padding: '7px 0 0 7px', }}>
        </Col>
        <Col sm={12} md={8} lg={9} style={{ color: '#fff', background: 'var(--brand-navy' }}>
          <a href="/login"><img src="/images/logos/avannis_logo_white.png" height="90px;" alt="Avannis" width=""></img></a>
        </Col>
      </Row>
      <Row className="rowNoMarginTop">
        <Col sm={12} md={4} lg={3} style={{ backgroundColor: '#fff', height: '1px' }}>
        </Col>
        <Col sm={12} md={8} lg={9} style={{ backgroundColor: 'white', padding: '20px' }}>
          <Container>
            <section>
              <h3>Forgot Username</h3>
            </section>
            <Row>
              <Col sm={12}>
                {
                  !showConfirmationBox ?
                    (
                      <form onSubmit={(e) => e.preventDefault()} className="padding" noValidate>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label>Please enter the email address associated with your reports.avannis.com account</Label>
                              <Input type="email" value={emailInput}
                                onChange={(e) => setEmailInput(e.currentTarget.value)} />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row style={{ paddingBottom: '20px' }}>
                          <Col md={6}>
                            <Button color="primary"
                              disabled={emailInput.length <= 0}
                              onClick={() => {
                                retrieveUsername(emailInput)
                              }}
                            >
                              {submitting ?
                                <>
                                  <span>Submitting...&nbsp;</span>
                                  <i className="fas fa-fw fa-cog fa-spin" />
                                </>
                                :
                                <>
                                  <span>Submit&nbsp;</span>
                                  <i className="fas fa-fw fa-paper-plane" />
                                </>
                              }
                            </Button>
                          </Col>
                        </Row>
                      </form>
                    ) :
                    <>
                      <Alert color="info">
                        If <a href={`mailto:${emailInput}`}>{emailInput}</a> was found in our database, then an email was sent with further instructions.
                      </Alert>
                      <Button onClick={(e) => {
                        window.location.href = 'login'
                      }
                      }>Go To Login</Button>
                    </>
                }
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
    </div>
  );
}
